<template>
    <div v-if="lang === 'ru'" class="flex w-full flex-column gap-2">
        <h1 class="text-900 font-medium text-xl">
            Политика по противодействию отмыванию денежных средств (AML)
        </h1>
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            1. Общие положения
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Настоящая Политика AML (далее — «Политика») определяет подход проекта PayWave к предупреждению и противодействию отмыванию денежных средств, финансированию терроризма и другим формам финансового злоупотребления. PayWave принимает на себя обязательства по соблюдению международных стандартов в этой области.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            2. Принципы и цели
        </h2>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Обеспечение прозрачности операций на платформе;</li>
            <li>Соблюдение принципа «Знай своего клиента» (KYC);</li>
            <li>Пресечение попыток использования Сервиса в преступных целях;</li>
            <li>Выявление и предотвращение подозрительных операций;</li>
            <li>Ведение учёта и внутренней отчётности по рисковым случаям.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            3. Идентификация и проверка клиентов (KYC)
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.1. Для Пользователей платформа применяет выборочный принцип верификации личности, основанный на характере и объёмах операций. Проверка может потребоваться при использовании конкретных функций, выходящих за рамки стандартных лимитов или повышающих уровень риска.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.2. Для мерчантов (торгующих сторон) процедура идентификации обязательна в полном объёме без исключений перед получением доступа к функционалу платформы.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.3. Верификация проводится внутренней службой безопасности проекта PayWave на основании предоставленных Пользователем документов, включая:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>паспорт/удостоверение личности,</li>
            <li>селфи с документом,</li>
            <li>подтверждение адреса (при необходимости),</li>
            <li>иные документы по запросу.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            4. Классификация рисков
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            Сервис применяет риск-ориентированный подход. Повышенному контролю подлежат:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>пользователи с аномальной активностью;</li>
            <li>транзакции с несоответствием по юрисдикции, объёмам или частоте;</li>
            <li>операции, предполагающие обход валютного регулирования;</li>
            <li>использование подставных лиц или неполных данных.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            5. Мониторинг и внутренний контроль
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.1. PayWave внедряет внутренние механизмы мониторинга транзакций для выявления подозрительных действий.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.2. Внутренняя команда вправе:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>приостановить выполнение перевода,</li>
            <li>запросить дополнительные сведения,</li>
            <li>заблокировать доступ к Сервису до прояснения ситуации.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            6. Блокировка и отказ в обслуживании
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.1. В случае обоснованных подозрений в нарушении требований AML/KYC или попытках использования платформы в противоправных целях PayWave оставляет за собой право:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>отказать в регистрации или верификации;</li>
            <li>приостановить или заблокировать аккаунт;</li>
            <li>прекратить оказание услуг без предварительного уведомления.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.2. Решения по блокировкам и отказам принимаются в индивидуальном порядке и могут сопровождаться документальным обоснованием.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            7. Ответственность и сотрудничество с регуляторами
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            При необходимости и в рамках действующего законодательства проект PayWave готов взаимодействовать с компетентными органами и предоставлять данные, связанные с подозрительными операциями, по соответствующим запросам.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            8. Обновление политики
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            PayWave оставляет за собой право вносить изменения в настоящую Политику в любое время. Актуальная версия доступна по адресу: <a href="https://pay-wave.co/aml/" class="text-primary" target="_blank">https://pay-wave.co/aml/</a>
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            9. Контактная информация
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Проект PayWave
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Email: <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Telegram: <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Сайт: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
        </p>
    </div>
    <div v-else class="flex w-full flex-column gap-2">
        <h1 class="text-900 font-medium text-xl">
            Anti-Money Laundering Policy (AML)
        </h1>
        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            1. General Provisions
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            This AML Policy (hereinafter referred to as the "Policy") defines the approach of the PayWave project to the prevention and counteraction of money laundering, terrorist financing, and other forms of financial abuse. PayWave undertakes to comply with international standards in this area.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            2. Principles and Objectives
        </h2>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>Ensuring transparency of operations on the platform;</li>
            <li>Compliance with the "Know Your Customer" (KYC) principle;</li>
            <li>Preventing attempts to use the Service for criminal purposes;</li>
            <li>Detection and prevention of suspicious operations;</li>
            <li>Maintaining records and internal reporting on risk cases.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            3. Customer Identification and Verification (KYC)
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.1. For Users, the platform applies a selective identity verification principle based on the nature and volume of operations. Verification may be required when using specific functions that exceed standard limits or increase the risk level.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.2. For merchants (trading parties), the identification procedure is mandatory in full without exception before gaining access to the platform's functionality.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            3.3. Verification is carried out by the internal security service of the PayWave project based on the documents provided by the User, including:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>passport/ID card,</li>
            <li>selfie with the document,</li>
            <li>proof of address (if necessary),</li>
            <li>other documents upon request.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            4. Risk Classification
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            The Service applies a risk-based approach. Increased control is applied to:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>users with abnormal activity;</li>
            <li>transactions with discrepancies in jurisdiction, volume, or frequency;</li>
            <li>operations intended to circumvent currency regulation;</li>
            <li>use of nominees or incomplete data.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            5. Monitoring and Internal Control
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.1. PayWave implements internal transaction monitoring mechanisms to detect suspicious actions.
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            5.2. The internal team has the right to:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>suspend the transfer,</li>
            <li>request additional information,</li>
            <li>block access to the Service until the situation is clarified.</li>
        </ul>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            6. Blocking and Refusal of Service
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.1. In case of reasonable suspicion of violation of AML/KYC requirements or attempts to use the platform for illegal purposes, PayWave reserves the right to:
        </p>
        <ul class="flex flex-column text-sm xl:text-base lg:text-base md:text-base mb-2 pl-3 gap-2">
            <li>refuse registration or verification;</li>
            <li>suspend or block the account;</li>
            <li>terminate services without prior notice.</li>
        </ul>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            6.2. Decisions on blocking and refusals are made individually and may be accompanied by documentary justification.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            7. Responsibility and Cooperation with Regulators
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            If necessary and within the framework of applicable law, the PayWave project is ready to cooperate with competent authorities and provide data related to suspicious operations upon appropriate requests.
        </p>
        <hr />

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            8. Policy Updates
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base">
            PayWave reserves the right to make changes to this Policy at any time. The current version is available at: <a href="https://pay-wave.co/aml/" class="text-primary" target="_blank">https://pay-wave.co/aml/</a>
        </p>

        <h2 class="text-900 font-medium text-lg xl:text-xl lg:text-xl md:text-lg sm:text-lg">
            9. Contact Information
        </h2>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            PayWave Project
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Email: <a href="mailto:info@pay-wave.co" class="text-primary">info@pay-wave.co</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Telegram: <a href="https://t.me/pw_origin_bot" class="text-primary" target="_blank">https://t.me/pw_origin_bot</a>
        </p>
        <p class="text-sm xl:text-base lg:text-base md:text-base mb-0">
            Website: <a href="https://pay-wave.co/" class="text-primary" target="_blank">https://pay-wave.co/</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'AML',
        computed: {
            lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        },
    }
</script>
